(function() {
  window.CV_Countdown = function CV_Countdown(deadline, container) {
    this.deadline = deadline;
    this.container = container;

    this.update = function update() {
      var {total, days, hours, minutes, seconds} = this.getTimeRemaining(this.deadline);

      this.container.find('.countdown__timer-days .value').text(this.padValue(days));
      this.container.find('.countdown__timer-hours .value').text(this.padValue(hours));
      this.container.find('.countdown__timer-minutes .value').text(this.padValue(minutes));
      this.container.find('.countdown__timer-seconds .value').text(this.padValue(seconds));
    }

    this.getTimeRemaining = function getTimeRemaining() {
        var total = Date.parse(this.deadline) - Date.parse(new Date()),
         seconds = Math.floor( (total / 1000) % 60 ),
         minutes = Math.floor( (total / 1000 / 60) % 60 ),
         hours = Math.floor( (total / (1000*60*60)) % 24 ),
         days = Math.floor( total / (1000*60*60*24) );

        return { total, days, hours, minutes, seconds};
    }

    this.padValue = function padValue(num) {
      return ('000000000' + num).substr(-2);
    }
  }
})();


